<template>
    <el-dialog width="650px" title="购买结算" :visible.sync="viewDetail" @close="closeModel">
        <div>
            <el-row :gutter="20">
                <el-col :span="4">
                    <img :src="rowdetail.url" style="width: 100%; height: 80px" />
                </el-col>
                <el-col :span="20">
                    <p class="p-text">{{ rowdetail.name }}</p>
                    <p class="p-text">价格 : {{ rowdetail.price }}</p>
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle">
                <el-col :span="5" style="font-size: 18px"> 购买数量 : </el-col>
                <el-col :span="4">
                    <el-input v-model="num"></el-input>
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle">
                <el-col :span="5" style="font-size: 18px"> 结算方式 : </el-col>
                <el-col :span="4" style="display: flex">
                    <el-radio v-model="pay_type" @change="payCreate_" label="1">支付宝</el-radio>
                    <el-radio v-model="pay_type" @change="payCreate_" label="2">微信</el-radio>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="5">&nbsp;</el-col>
                <el-col :span="4" class="right">
                    <div class="div img" v-loading="urlLoad" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <vue-qr :text="qrUrl" qid="testid" :margin="0" v-if="qrUrl"></vue-qr>
                        <div class="block" v-else>
                            <el-image>
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeModel">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { payCreate, apishopPayment, getPayQuery } from "@/api/operate/index";
import VueQr from "vue-qr";
export default {
    props: {
        rowdetail: {
            type: Object,
        },
    },
    data() {
        return {
            viewDetail: true,
            num: 1,
            pay_type: "1",
            qrUrl: "",
            urlLoad: "",
        };
    },
    mounted() {},
    methods: {
        closeModel() {
            clearInterval(this.timer)
            this.$emit("closeModel");
        },
        // handleSubmit() {
        //     this.payCreate_();
        // },
        payCreate_() {
            this.urlLoad = true;
            let par = {
                token: this.$getSessionStorage("token"),
                buy_number: this.num,
                package_id: this.rowdetail.id,
                pay_type: this.pay_type,
            };
            payCreate(par)
                .then((res) => {
                    if (res.code == 1) {
                        // this.$message.success({ message: "购买成功" });
                        // this.closeModel();
                        this.apishopPaymentFunc(res.data.payment_id);
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        apishopPaymentFunc(id) {
            clearInterval(this.timer);
            apishopPayment({ id: id }).then((res) => {
                if (res.code == 1) {
                    this.qrUrl = res.data.pay_url;
                    if (!res.data.pay_url) {
                        this.$message.warning("已提交过申请，请等待审核！");
                        this.imgDialog = false;
                    } else {
                        this.qrUrl = res.data.pay_url;
                        this.urlLoad = false;
                        let i = 0;
                        this.timer = setInterval(() => {
                            this.checkPay(id);
                            i++;
                            if (i >= 20) {
                                clearInterval(this.timer);
                            }
                        }, 3000);
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        checkPay(id) {
            let opt = {
                id: id,
                token: this.getToken,
            };
            getPayQuery(opt).then(({ data }) => {
                if (data.code == 1) {
                    if (data.data.status == 2) {
                        clearInterval(this.timer);
                        this.$message.success("支付成功！");
                        this.dialogVisible = false;
                        this.$emit("init");
                    } else if (data.data.status == 3) {
                        clearInterval(this.timer);
                        this.$message.error("支付失败！");
                    }
                }
            });
        },
    },
    components: { VueQr },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped lang="scss">
.p-text {
    font-size: 18px;
    margin-top: 10px;
    padding-left: 20px;
}
::v-deep .el-row {
    margin-top: 20px !important;
}
.right {
    padding-left: 60px;
    flex: 1;
    display: flex;
    align-items: center;
    .img {
        img,
        .el-image {
            width: 140px;
            height: 140px;
            background: #eee;
            font-size: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
